export enum PanelState {
    Opened = 1,
    Expanded = 2,
    Collapsed = 3
}
